var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6682_4095",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 134
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 134V0H133.958V134H0Z",
    fill: "#D5915B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6682_4095)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.963 66.9599C133.963 103.986 103.947 134.002 66.9208 134.002C29.8948 134.002 -0.121094 103.986 -0.121094 66.9599C-0.121094 29.9339 29.8948 -0.0820312 66.9208 -0.0820312C103.947 -0.0820312 133.963 29.9339 133.963 66.9599Z",
    fill: "url(#paint0_linear_6682_4095)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.803 102.994H44.2361C42.8723 102.994 41.5643 102.453 40.5999 101.488C39.6355 100.524 39.0938 99.2159 39.0938 97.8521V39.5723V94.4239C39.0938 95.7877 39.6355 97.0957 40.5999 98.06C41.5643 99.0244 42.8723 99.5662 44.2361 99.5662H88.803C90.1668 99.5662 91.4748 99.0244 92.4392 98.06C93.4036 97.0957 93.9454 95.7877 93.9454 94.4239V97.8521C93.9454 99.2159 93.4036 100.524 92.4392 101.488C91.4748 102.453 90.1668 102.994 88.803 102.994Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2361 31.5H72.876V46.427C72.876 47.9235 73.4705 49.3586 74.5286 50.4167C75.5868 51.4749 77.0219 52.0693 78.5183 52.0694H93.4454V94.4222C93.4454 95.6534 92.9562 96.8342 92.0856 97.7048C91.215 98.5754 90.0342 99.0645 88.803 99.0645H44.2361C43.0049 99.0645 41.8241 98.5754 40.9535 97.7048C40.0829 96.8342 39.5938 95.6534 39.5938 94.4222V36.1423C39.5938 34.9111 40.0829 33.7303 40.9535 32.8597C41.8241 31.9891 43.0049 31.5 44.2361 31.5Z",
    fill: "#222222",
    stroke: "#2C2C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.875 46.427V32.2071L92.7372 51.0693H78.5173C77.2861 51.0693 76.1053 50.5802 75.2347 49.7096C74.3641 48.839 73.875 47.6582 73.875 46.427Z",
    fill: "#222222",
    stroke: "#2C2C2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2254 73.7921V73.6429C64.242 72.0603 64.4077 70.8008 64.7226 69.8645C65.0375 68.9282 65.4849 68.17 66.0649 67.59C66.6449 67.01 67.341 66.4756 68.153 65.9867C68.6419 65.6884 69.081 65.3362 69.4705 64.9302C69.8599 64.5159 70.1665 64.0395 70.3902 63.5009C70.6222 62.9623 70.7382 62.3657 70.7382 61.7111C70.7382 60.8991 70.5476 60.1948 70.1665 59.5982C69.7853 59.0016 69.2757 58.5417 68.6377 58.2186C67.9997 57.8954 67.2912 57.7338 66.5124 57.7338C65.8329 57.7338 65.1783 57.8747 64.5486 58.1564C63.9188 58.4382 63.3927 58.8815 62.9701 59.4863C62.5475 60.0912 62.3031 60.8825 62.2368 61.8603H59.1047C59.171 60.4516 59.5356 59.246 60.1984 58.2434C60.8696 57.2408 61.7521 56.4744 62.8458 55.9441C63.9478 55.4138 65.17 55.1486 66.5124 55.1486C67.9707 55.1486 69.2384 55.4386 70.3156 56.0186C71.4011 56.5987 72.238 57.3941 72.8263 58.405C73.4229 59.4159 73.7212 60.5676 73.7212 61.8603C73.7212 62.7717 73.5803 63.5962 73.2986 64.3336C73.0251 65.0711 72.6274 65.7298 72.1054 66.3098C71.5917 66.8899 70.9702 67.4036 70.2411 67.851C69.5119 68.3068 68.9277 68.7873 68.4886 69.2928C68.0494 69.79 67.7304 70.3824 67.5315 71.0701C67.3327 71.7579 67.225 72.6155 67.2084 73.6429V73.7921H64.2254ZM65.8163 81.15C65.2032 81.15 64.677 80.9305 64.2379 80.4913C63.7987 80.0521 63.5791 79.526 63.5791 78.9128C63.5791 78.2997 63.7987 77.7735 64.2379 77.3343C64.677 76.8952 65.2032 76.6756 65.8163 76.6756C66.4295 76.6756 66.9557 76.8952 67.3948 77.3343C67.834 77.7735 68.0536 78.2997 68.0536 78.9128C68.0536 79.3188 67.95 79.6917 67.7428 80.0314C67.544 80.3712 67.2747 80.6446 66.9349 80.8517C66.6035 81.0506 66.2306 81.15 65.8163 81.15Z",
    fill: "#FFC97A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6682_4095",
    x1: 2.56058,
    y1: 2.73373,
    x2: 96.017,
    y2: 87.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525050",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1048156a560c9bdbbac5cd1ca88d1daa.svg";
export { ForwardRef as ReactComponent };